const API_BASE_URL = "https://cooperadora.ipet50.edu.ar/api/routes";

// Esta URL tiene prioridad ABSOLUTA: no se lee REACT_APP_API_URL,
// .env, hostname ni otras configuraciones del entorno.
const BASE_URL = API_BASE_URL.trim().replace(/\/+$/, "");

// Panel del bot: se mantiene apuntando al bot real de producción.
// No cambia al modificar la URL de la API principal.
// El panel de WhatsApp es una API independiente: se conserva en producción.
// Sus componentes importan estas constantes desde este único archivo.
// No se permite que variables .env las sobrescriban silenciosamente.
export const BOT_PANEL_URL =
  "https://cooperadora.ipet50.edu.ar/api/bot_wp/funciones/Panel/endpoints";

export const BOT_PANEL_PUNTOS_URL =
  "https://cooperadora.ipet50.edu.ar/api/bot_wp/funciones/Panel/puntos";

export default BASE_URL;


// Desarrollo local:
// php -c "C:\\php\\php.ini" -S localhost:3001
// URL LOCAL= http://localhost:3001/routes
// URL PRODUCCIÓN= https://cooperadora.ipet50.edu.ar/api/routes

// npx playwright test --project=chromium --workers=1 --reporter=list
